<div class="chart-fullscreen-dialog">
  <div class="chart-fullscreen-header">
    <span class="chart-fullscreen-title">{{ data.title }}</span>
    <button type="button" class="chart-fullscreen-close" mat-dialog-close aria-label="Close" title="Close">&times;</button>
  </div>
  <div #chartContainer class="chart-fullscreen-chart"></div>
</div>
